import React from 'react';
import { CalendarIcon } from 'lucide-react';

interface NoHarborProps {
  message?: string;
}

export const NoHarborState: React.FC<NoHarborProps> = ({
  message = 'Please select a harbor to view availability calendar.',
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-xl p-8 text-center max-w-md">
        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <CalendarIcon className="w-8 h-8 text-blue-600" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          No Harbor Selected
        </h3>
        <p className="text-gray-600">{message}</p>
      </div>
    </div>
  );
};

interface NoEventsProps {
  onResetFilters: () => void;
  isLoading: boolean;
}

export const NoEventsState: React.FC<NoEventsProps> = ({
  onResetFilters,
  isLoading,
}) => {
  if (isLoading) return null;

  return (
    <div className="rounded-2xl shadow-lg border border-gray-100 p-12 text-center mb-8">
      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <CalendarIcon className="w-8 h-8 text-gray-400" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        No Events Found
      </h3>
      <p className="text-gray-600 mb-4">
        No events match your current filters. Try adjusting your filters to see
        more results.
      </p>
      <button
        onClick={onResetFilters}
        className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium"
      >
        Reset Filters
      </button>
    </div>
  );
};

interface LoadingStateProps {
  isLoading: boolean;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="bg-blue-50 dark:bg-blue-950 contrast:bg-blue-950 border border-blue-200 dark:border-blue-900 contrast:border-blue-900 rounded-xl p-4 mb-6">
      <div className="flex items-center gap-3">
        <div className="w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
        <span className="text-blue-700 dark:text-blue-200 contrast:text-blue-200 font-medium">
          Refreshing calendar data...
        </span>
      </div>
    </div>
  );
};

interface WarningMessageProps {
  totalBerths: number;
}

export const WarningMessage: React.FC<WarningMessageProps> = ({
  totalBerths,
}) => {
  if (totalBerths === undefined || totalBerths > 0) return null;

  return (
    <div className="bg-amber-50 dark:bg-amber-950 contrast:bg-amber-950 border border-amber-200 dark:border-amber-900 contrast:border-amber-900 rounded-xl p-4 mb-6">
      <div className="flex items-center gap-3">
        <div className="w-5 h-5 bg-amber-500 rounded-full flex items-center justify-center">
          <span className="text-black text-xs font-bold">
            !
          </span>
        </div>
        <span className="text-amber-700 dark:text-amber-200 contrast:text-amber-200">
          No berths found for this harbor (showing bookings only).
        </span>
      </div>
    </div>
  );
};
